import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import "./Tooltip.css";

export default function Tooltip({ content, children }) {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const wrapperRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (visible && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + 6 + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  }, [visible]);

  const handleMouseEnter = () => {
    timeoutRef.current = setTimeout(() => setVisible(true), 500); // 0.5s delay
  };

  const handleMouseLeave = () => {
    clearTimeout(timeoutRef.current);
    setVisible(false);
  };

  return (
    <>
      <span
        ref={wrapperRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="tooltip-wrapper"
      >
        {children}
      </span>
      {visible &&
        createPortal(
          <div
            className="tooltip-box"
            style={{
              top: `${position.top}px`,
              left: `${position.left}px`,
            }}
          >
            {content}
          </div>,
          document.body
        )}
    </>
  );
}
